{
  "v4.design.annuler": "Annuler",
  "v4.design.aucun": "aucun",
  "v4.design.catalogue": "le catalogue des choix de charte",
  "v4.design.charte.afficher_jetons": "Afficher les jetons",
  "v4.design.charte.aucune_effective": "Aucune version validée : le projet suit la charte héritée ou par défaut.",
  "v4.design.charte.effective": "Version effective du projet : version {{version}} ({{semver}})",
  "v4.design.charte.enregistrer": "Enregistrer une nouvelle version",
  "v4.design.charte.entete": "Version {{version}} ({{semver}}) — {{statut}}",
  "v4.design.charte.historique": "Historique des versions",
  "v4.design.charte.historique_vide": "Aucune version antérieure.",
  "v4.design.charte.jetons": "Jetons de la version",
  "v4.design.charte.libelle": "la charte",
  "v4.design.charte.ligne_historique": "Version {{version}} ({{semver}}), {{statut}}, par {{auteur}} le {{date}}",
  "v4.design.charte.masquer_jetons": "Masquer les jetons",
  "v4.design.charte.non_brouillon": "Seul un brouillon se valide.",
  "v4.design.charte.nouvelle": "Nouvelle version",
  "v4.design.charte.origine.organisation": "Charte héritée de l’organisation.",
  "v4.design.charte.origine.project": "Charte propre au projet.",
  "v4.design.charte.relue": "J’ai relu la version {{version}} de la charte (empreinte {{empreinte}}).",
  "v4.design.charte.revenir": "Revenir à la charte héritée",
  "v4.design.charte.revenir_confirmer": "Confirmer le retour à la charte héritée",
  "v4.design.charte.revenir_echec": "Le retour à la charte héritée n’a pas abouti.",
  "v4.design.charte.revenir_effets": "La surcharge active prend fin : le projet suit de nouveau la charte de l’organisation. Aucune dérogation de l’organisation n’est levée.",
  "v4.design.charte.revenir_sans_surcharge": "Aucune surcharge active : le projet suit déjà la charte héritée.",
  "v4.design.charte.revenue": "Le projet suit de nouveau la charte héritée.",
  "v4.design.charte.statut.draft": "brouillon",
  "v4.design.charte.statut.superseded": "remplacée",
  "v4.design.charte.statut.validated": "validée",
  "v4.design.charte.surcharge": "Solliciter une surcharge",
  "v4.design.charte.titre": "Charte du produit",
  "v4.design.charte.validation": "Validation par une autre personne",
  "v4.design.charte.validation_echec": "La charte n’a pas été validée.",
  "v4.design.charte.validee": "Charte validée.",
  "v4.design.charte.validee_par": "— validée par {{nom}} le {{date}}",
  "v4.design.charte.valider": "Valider la charte",
  "v4.design.charte.vide": "Aucune version de charte.",
  "v4.design.choix.angles": "Angles",
  "v4.design.choix.couleur": "Couleur principale",
  "v4.design.choix.densite": "Densité",
  "v4.design.choix.fond": "Fond de page",
  "v4.design.choix.logo": "Logo (texte)",
  "v4.design.choix.logo_style": "Présentation du logo",
  "v4.design.choix.palette": "Palette {{nom}}",
  "v4.design.choix.ton": "Ton (typographie)",
  "v4.design.choix.voix": "Voix des libellés",
  "v4.design.code.CREATEUR_N_APPROUVE_PAS": "Qui a créé la version ne la valide pas : une autre personne du projet la valide.",
  "v4.design.code.DESIGN_CHARTER_NOT_DRAFT": "Seul un brouillon se valide : cette version l’est déjà ou a été remplacée.",
  "v4.design.code.DESIGN_CHARTER_NOT_FOUND": "Cette version de charte est introuvable dans ce projet.",
  "v4.design.code.DESIGN_CHARTER_OUTDATED": "La charte a changé depuis votre lecture : rechargez la fiche, relisez la nouvelle version puis validez-la.",
  "v4.design.code.DESIGN_COMPARISON_NOT_FOUND": "Cette comparaison est introuvable dans ce projet.",
  "v4.design.code.DESIGN_CONTRAST_INSUFFICIENT": "Contraste insuffisant : choisissez une couleur principale plus foncée ou un fond plus clair.",
  "v4.design.code.DESIGN_FLOW_NOT_FOUND": "Ce parcours est introuvable dans ce projet.",
  "v4.design.code.DESIGN_FLOW_VERSION_CONFLICT": "Le parcours ou la maquette a changé depuis votre lecture : rechargez la fiche et relisez avant de valider.",
  "v4.design.code.DESIGN_NOT_DRAFT": "Seul un brouillon se valide.",
  "v4.design.code.DESIGN_OVERRIDE_REQUIRED": "La charte de l’organisation s’applique : demandez d’abord une surcharge motivée.",
  "v4.design.code.DESIGN_SELF_VALIDATION_REFUSED": "L’auteur ne valide pas sa propre version : une autre personne du projet la valide.",
  "v4.design.code.DESIGN_USABILITY_DATE_FUTURE": "Une séance ne se déclare pas avant d’avoir eu lieu.",
  "v4.design.code.DESIGN_USABILITY_FINAL": "Ce test est déjà définitif.",
  "v4.design.code.DESIGN_WIREFRAME_NOT_FOUND": "Cette maquette est introuvable dans ce projet.",
  "v4.design.code.WORKSPACE_ARCHIVED": "Le projet est archivé : il est en lecture seule.",
  "v4.design.comparaison.afficher_maquette": "Afficher la maquette de {{nom}}",
  "v4.design.comparaison.apercus": "Voir les aperçus de la révision",
  "v4.design.comparaison.aucun_ecart": "Aucun écart relevé.",
  "v4.design.comparaison.avis.aligned": "Conforme à la maquette",
  "v4.design.comparaison.avis.major_gaps": "Écarts majeurs",
  "v4.design.comparaison.avis.minor_gaps": "Écarts mineurs",
  "v4.design.comparaison.avis.nothing_compared": "Rien de comparé",
  "v4.design.comparaison.avis.partial": "Comparaison partielle : des écrans n’ont pas été mesurés",
  "v4.design.comparaison.compteurs": "Écrans attendus : {{attendus}} ; comparés : {{compares}} ; absents : {{absents}}. Écarts majeurs : {{majeurs}} ; mineurs : {{mineurs}} ; pour information : {{infos}}.",
  "v4.design.comparaison.cote_maquette": "Maquette de {{nom}}",
  "v4.design.comparaison.cote_realisation": "Réalisation de {{nom}}",
  "v4.design.comparaison.ecarts": "Écarts par écran",
  "v4.design.comparaison.ecran": "{{nom}} ({{route}}) : {{n}} écart(s)",
  "v4.design.comparaison.entete": "Révision {{revision}} comparée au parcours version {{version}}",
  "v4.design.comparaison.libelle": "la comparaison",
  "v4.design.comparaison.nature.autre": "Autre écart",
  "v4.design.comparaison.nature.connexion_requise": "Connexion requise, écran non mesuré",
  "v4.design.comparaison.nature.couleur_hors_charte": "Couleur hors charte",
  "v4.design.comparaison.nature.ecran_manquant": "Écran manquant",
  "v4.design.comparaison.nature.element_manquant": "Élément manquant",
  "v4.design.comparaison.nature.element_supplementaire": "Élément en plus",
  "v4.design.comparaison.nature.maquette_illisible": "Maquette illisible",
  "v4.design.comparaison.nature.maquette_manquante": "Maquette manquante",
  "v4.design.comparaison.nature.nombre_champs_different": "Nombre de champs différent",
  "v4.design.comparaison.nature.titre_different": "Titre différent",
  "v4.design.comparaison.realisation": "Réalisation : {{route}} de la révision {{revision}}, captures {{largeurs}} px",
  "v4.design.comparaison.rien_a_montrer": "{{nom}} : ni maquette validée ni écran réalisé à montrer.",
  "v4.design.comparaison.sans_maquette": "Aucune maquette validée pour cet écran.",
  "v4.design.comparaison.sans_realisation": "L’écran ne répond pas dans la réalisation.",
  "v4.design.comparaison.titre": "Comparaison avec la maquette",
  "v4.design.comparaison.voir_parcours": "Voir le parcours",
  "v4.design.comparaison.vues": "Vues côte à côte",
  "v4.design.contraste.bloque": "Enregistrement impossible : {{n}} paire(s) sous le minimum de contraste.",
  "v4.design.contraste.conforme": "Contraste conforme sur les {{n}} paires vérifiées (WCAG 2.2 AA).",
  "v4.design.contraste.juste": "Tout juste lisible — {{paire}} : {{ratio}}.",
  "v4.design.contraste.non_calcule": "Contraste non calculé : couleur à compléter.",
  "v4.design.contraste.paire": "{{paire}} : {{ratio}} (minimum {{minimum}})",
  "v4.design.derogation": "Voir la dérogation",
  "v4.design.ecran_non_realise": "« {{ecran}} » : écran non encore réalisé, servi par un autre paquet de la vague.",
  "v4.design.et": "et",
  "v4.design.etat.chargement": "Chargement de {{quoi}}…",
  "v4.design.etat.en_cours": "En cours…",
  "v4.design.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v4.design.etat.introuvable": "Introuvable : {{quoi}}.",
  "v4.design.etat.reessayer": "Réessayer",
  "v4.design.etat.refus": "Accès refusé : {{quoi}}.",
  "v4.design.heritage.defaut": "Aucune charte propre au projet n’est requise : sans elle, le projet suit la charte par défaut.",
  "v4.design.heritage.derogation_requise": "Une charte propre au projet ne sera validée qu’avec une dérogation accordée par l’organisation.",
  "v4.design.heritage.impose": "Charte de l’organisation héritée : version {{version}} ({{semver}}), imposée.",
  "v4.design.heritage.libelle": "la charte héritée",
  "v4.design.heritage.recommande": "Charte de l’organisation héritée : version {{version}} ({{semver}}), recommandée.",
  "v4.design.parcours.aucune_maquette": "Aucune maquette pour ce parcours.",
  "v4.design.parcours.criteres_ecran": "Critères servis par l’écran {{n}} (séparés par des virgules)",
  "v4.design.parcours.document_source": "Voir le document source",
  "v4.design.parcours.edition": "Nouvelle version du parcours",
  "v4.design.parcours.enregistre": "Nouvelle version du parcours enregistrée, à valider.",
  "v4.design.parcours.enregistrement_echec": "La nouvelle version n’a pas été enregistrée.",
  "v4.design.parcours.enregistrer": "Enregistrer une nouvelle version",
  "v4.design.parcours.entete": "Version {{version}} — {{etat}}, par {{auteur}}",
  "v4.design.parcours.etat.perime": "périmé",
  "v4.design.parcours.etat.propose": "proposé",
  "v4.design.parcours.etat.valide": "validé",
  "v4.design.parcours.etat_maquette.a_valider": "à valider",
  "v4.design.parcours.etat_maquette.perimee": "périmée",
  "v4.design.parcours.etat_maquette.validee": "validée",
  "v4.design.parcours.invalide": "Chaque écran a un nom et une adresse commençant par « / ».",
  "v4.design.parcours.libelle": "le parcours",
  "v4.design.parcours.maquette": "Maquette {{ecran}} v{{version}} — {{etat}}",
  "v4.design.parcours.maquette_libelle": "la maquette",
  "v4.design.parcours.maquette_relue": "J’ai relu la maquette {{ecran}} v{{version}} (empreinte {{empreinte}}).",
  "v4.design.parcours.maquette_relue_sans": "J’ai relu la maquette choisie.",
  "v4.design.parcours.maquette_validee": "Maquette validée.",
  "v4.design.parcours.maquettes": "Maquettes",
  "v4.design.parcours.nom_ecran": "Nom de l’écran {{n}}",
  "v4.design.parcours.non_servis": "Critères non servis : {{liste}}",
  "v4.design.parcours.reference": "Maquette {{ecran}}, version {{version}}, empreinte {{empreinte}}, par {{auteur}}",
  "v4.design.parcours.relu": "J’ai relu la version {{version}} du parcours.",
  "v4.design.parcours.rendu": "Ouvrir le rendu de la maquette",
  "v4.design.parcours.route_ecran": "Adresse de l’écran {{n}}",
  "v4.design.parcours.sans_critere": "Écrans sans critère : {{liste}}",
  "v4.design.parcours.sans_source": "Écrit à la main, sans document source.",
  "v4.design.parcours.selection_requise": "Choisissez une maquette dans la liste.",
  "v4.design.parcours.source": "Issu de la décision n° {{id}}.",
  "v4.design.parcours.titre": "Parcours et maquettes",
  "v4.design.parcours.validation": "Validation du parcours",
  "v4.design.parcours.validation_echec": "La validation n’a pas abouti.",
  "v4.design.parcours.valide_ok": "Parcours validé.",
  "v4.design.parcours.valider": "Valider le parcours",
  "v4.design.parcours.valider_maquette": "Valider la maquette",
  "v4.design.preparer.cree": "Version de charte enregistrée en brouillon.",
  "v4.design.preparer.creer": "Créer la charte",
  "v4.design.preparer.distincte": "La première version est propre au projet, distincte de la charte héritée.",
  "v4.design.preparer.echec": "La version de charte n’a pas été enregistrée.",
  "v4.design.preparer.sans_validation": "Enregistrée en brouillon : une autre personne la valide ensuite.",
  "v4.design.preparer.titre": "Préparer une première charte",
  "v4.design.retour": "Retour au design",
  "v4.design.sans_projet": "Choisissez d’abord un projet.",
  "v4.design.usage.ajouter_observation": "Ajouter une observation",
  "v4.design.usage.aucune_derogation": "Aucune dérogation pour ce test.",
  "v4.design.usage.besoin_date": "Indiquez la date de la séance.",
  "v4.design.usage.besoin_definitif": "Confirmez que le résultat est définitif.",
  "v4.design.usage.besoin_observation": "Notez au moins une observation.",
  "v4.design.usage.besoin_participants": "Indiquez le nombre de participants effectifs.",
  "v4.design.usage.besoin_reussites": "Pour chaque tâche, indiquez combien de participants l’ont réussie (0 à {{max}}).",
  "v4.design.usage.besoin_verdict": "Choisissez le verdict.",
  "v4.design.usage.choisir": "Choisir…",
  "v4.design.usage.conclusion": "Conclusion",
  "v4.design.usage.critere": "Critère d’usage : {{ref}} {{libelle}} ; réussite : {{reussite}}",
  "v4.design.usage.date": "Date de la séance",
  "v4.design.usage.date_future": "Une séance ne se déclare pas avant d’avoir eu lieu.",
  "v4.design.usage.definitif": "Le résultat est définitif : il ne sera plus modifiable.",
  "v4.design.usage.definitif_lecture": "Résultat définitif : il n’est plus modifiable.",
  "v4.design.usage.derogation_indisponible": "Solliciter une dérogation : indisponible tant que le circuit de l’organisation n’est pas arbitré.",
  "v4.design.usage.derogee": "Test dérogé : {{motif}}",
  "v4.design.usage.echec": "Le résultat n’a pas été enregistré.",
  "v4.design.usage.enregistre": "Résultat enregistré.",
  "v4.design.usage.enregistrer": "Enregistrer le résultat",
  "v4.design.usage.entete": "{{titre}} — {{etat}}",
  "v4.design.usage.etat.a_realiser": "à réaliser",
  "v4.design.usage.etat.deroge": "dérogé",
  "v4.design.usage.etat.realise": "réalisé",
  "v4.design.usage.gravite": "Gravité {{n}}",
  "v4.design.usage.gravites.blocking": "Bloquante",
  "v4.design.usage.gravites.info": "Information",
  "v4.design.usage.gravites.major": "Majeure",
  "v4.design.usage.gravites.minor": "Mineure",
  "v4.design.usage.introuvable": "Ce test d’usage est introuvable dans ce projet.",
  "v4.design.usage.libelle": "le test d’usage",
  "v4.design.usage.observation": "Observation {{n}}",
  "v4.design.usage.observation_vide": "Remplissez l’observation en cours avant d’en ajouter une autre.",
  "v4.design.usage.participants": "{{n}} participants prévus ({{profil}})",
  "v4.design.usage.presents": "Participants effectifs",
  "v4.design.usage.resultat": "Résultat de la séance",
  "v4.design.usage.reussie_par": "{{tache}} : réussie par (sur {{max}})",
  "v4.design.usage.sans_critere": "non précisée",
  "v4.design.usage.titre": "Test d’usage",
  "v4.design.usage.verdict": "Verdict",
  "v4.design.usage.verdict_lecture": "Verdict : {{verdict}} (séance du {{date}}, {{n}} participants).",
  "v4.design.usage.verdicts.failed": "Échoué",
  "v4.design.usage.verdicts.partial": "Partiel",
  "v4.design.usage.verdicts.passed": "Réussi"
}
